"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addSink = void 0;
var state_1 = require("./state");
var addSink = function (sink) {
    var state = (0, state_1.getState)();
    if (!sink.name || !sink.handler) {
        throw "Cannot add a sink: invalid arguments.";
    }
    if (state.sinks.find(function (_) { return _.name === sink.name; })) {
        return;
    }
    state.sinks.push(sink);
    for (var i = 0; i < state.eventQueue.length; i++) {
        if (state.eventQueue[i].isSuspended) {
            break;
        }
        var modifiedEvent = state.middlewares.reduce(function (e, middleware) { return middleware.handler(e); }, state.eventQueue[i]);
        sink.handler(modifiedEvent);
    }
};
exports.addSink = addSink;
